import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.checkliste-hinzufuegen-multi';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenChecklisteHinzufuegenMultiEffects {

    ChecklisteHinzufuegenMulti$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_CHECKLISTE_HINZUFUEGEN_MULTI),
        mergeMap((x: ac.PostChecklisteHinzufuegenMultiAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postChecklisteHinzufuegenMulti(x.checklisteHinzufuegenMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostChecklisteHinzufuegenMultiErfolgreichAction(result, x.checklisteHinzufuegenMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostChecklisteHinzufuegenMultiFehlerAction(error, x.checklisteHinzufuegenMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
